import React from "react";

const dash = `<!DOCTYPE html>
<html lang="en">
    <div style="text-align: center; font-weight: bold; color: #35BEDE; font-size: medium; margin-top: 15px;">FOLK Dashboard</div>

    <body class="dashboard-body">
        <div>
            <div class="report-cards-container">
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/YapZC"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Warriors Report - Weekly (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/p_ktqd159lnc"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Warriors Report - Monthly (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/p_nbsp71dlnc"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>FOLK Guide Report (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/p_h3dn767lnc"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Drill down report - Weekly (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/p_3q3jhx8lnc"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Drill down report - Montly (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/p_q8s0jc4tnc"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Date-wise Breakup Report (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://datastudio.google.com/u/1/reporting/1a485186-d2f3-4952-a7de-bdaceb996629/page/p_zg4jcunsnc"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Overall totals report (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://docs.google.com/spreadsheets/d/1OgKkUMSd7UwuF9xgp_kaCYW2L0MjwYjZlksTbZkPaXg/edit#gid=1931076648"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div style=" background-color: rgb(210, 95, 93); ">Detailed deficit report (Japa Yagna)</div>
                </a>
                <a class="overview-card-item" href="https://folk-dashboard.netlify.app/booking_curr_arrangement.html"
                    style="text-align:center; flex-direction: row; justify-content: center;">
                    <div style=" background-color: blueviolet; ">FOLK Vrindavan Report</div>
                </a>
                <a class="overview-card-item" href="/other_reports.html"
                        style="text-align:center; flex-direction: row; justify-content: center;">
                    <div>Other Reports</div>
                </a>
            </div>
        </div>
        <style>
            div.report-cards-container {
                display: flex;
                padding: 15px;
                flex-wrap: wrap;
                justify-content: space-around;
            }
            div.report-cards-container a {
                text-decoration: none;
                color: white;
                background-color: white;
                margin: 5px;
                border-radius: 5px;
                min-width: 25%;
                display: flex;

            }
            div.report-cards-container a div {
                text-decoration: none;
                color: white;
                background-color: #35BEDE;
                margin: 5px;
                border-radius: 5px;
                padding: 15px 5px;
                font-size: 16px;
                margin: 5px;
                width: 100%;
                height: 80%;
                text-align: center;
            }
            @media only screen and (max-width: 768px) {
                div.report-cards-container a {
                    width: 45% !important;
                }
                div.report-cards-container a div {
                    font-size: 12.5px;
                    font-weight: bold;
                }
                body {
                    background: url(../images/background.png);
                }
            }
        </style>
    </body>
    <script src="/js/index.js" type="module" crossorigin="anonymous"></script>
</html>
`;

export default function Dashboard() {
  return <div dangerouslySetInnerHTML={{ __html: dash }}></div>;
}
